export function myBorrowBookList (mode) {
  return { type: "HANDLE_BORROW_BOOK_LIST", payload: mode };
}
